/* eslint-disable
    prefer-rest-params
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
import ExportActions from 'exports/ExportActions';
import {FolderDefaultsKey} from 'FolderDefaults';
import ProtocolActions from 'notebook/protocols/actions/ProtocolActions';
import BasicInformationPanelView from 'toolbar/shared/BasicInformationPanelView';

class ProtocolInformationPanelView extends BasicInformationPanelView {
  folderDefaultsKey() {
    return FolderDefaultsKey.NOTEBOOK;
  }

  initialize() {
    this.saveModel = this.saveModel.bind(this);
    this.deleteModel = this.deleteModel.bind(this);
    this.requestExport = this.requestExport.bind(this);
    super.initialize(...arguments);
  }

  saveModel(data) {
    ProtocolActions.update(this.model.id, data, {success: this.onSaveSuccess});
  }

  deleteModel() {
    ProtocolActions.delete(this.model.id, {success: this.onDeleteSuccess});
  }

  requestExport() {
    ExportActions.requestExportFile(this.model.id);
  }
}

export default ProtocolInformationPanelView;
